// Hosts of the v3 API (chat-web-api-v3), per environment. The one source for
// config.BASE_API (lib/config/index.js) and the Shopify embedded page's
// preconnect, which vite.config.ts writes into shopify-admin.html at build
// time, so this file must stay free of browser-only imports.
export const API_V3_ORIGINS = {
  development: 'https://web.gke.zoko.dev',
  staging: 'https://stage.web.api.zoko.dev',
  production: 'https://web3.api.zoko.io',
  wicks: 'https://web-api-3.wickes.zoko.io',
}
